<template>
  <Navbar />
  <ScrollButton />

  <section
    class="banner-title"
    style="background-image: url(images/cable-group.jpg)"
  >
    <div class="auto-container">
      <div class="row clearfix">
        <div class="col-md-6 col-sm-6 col-xs-12 text-start">
          <h1>Kablo Gruplama Sistemleri</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12 text-end">
          <ul class="bread-crumb clearfix">
            <li><a href="/">Anasayfa</a></li>
            <li class="active">Kablo Gruplama Sistemleri</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="page-section" id="portfolio">
    <div class="container">
      <div class="text-uppercase line-wrapper">
        <div class="line"></div>
        <h2 class="text">Kablo Gruplama Ürünlerimiz</h2>
        <div class="line"></div>
      </div>
      <div class="row">
        <div
          class="col-lg-3 col-sm-6 mb-3"
          v-for="(item, index) in cables"
          :key="index"
        >
          <div class="portfolio-item">
            <a
              class="portfolio-link"
              data-bs-toggle="modal"
              :href="'#portfolioModal' + index"
            >
              <div class="portfolio-hover">
                <div class="portfolio-hover-content">
                  <font-awesome-icon icon="plus" />
                </div>
              </div>
             
  <img  class="img-fluid" :src="item.logo" :alt="item.baslik || 'Kablo Gruplama Ürünü'"  loading="lazy" decoding="async"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <Footer />

  <div
    class="portfolio-modal modal fade"
    v-for="(item, index) in cables"
    :key="index"
    :id="'portfolioModal' + index"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="close-modal" data-bs-dismiss="modal">
          <img src="images/close-icon.svg" alt="Kapat" />
        </div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8">
              <div class="modal-body">
                <img 
                  :src="item.logo"
                  :alt="item.baslik || 'Kablo Ürünü Detayı'" style="max-width: 100%; height: auto; border-radius: 8px;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useHead } from "@vueuse/head";
import { firestore } from "@/firebase/config";
import { query, collection, getDocs, where } from "firebase/firestore";

import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    Navbar,
    ScrollButton,
    Footer,
    FontAwesomeIcon,
  },
  setup() {
    const cables = ref([]);

    useHead({
      title: 'Kablo Gruplama | İntek Electronic',
      meta: [
        {
          name: 'description',
          content: 'Kablo gruplama çözümlerimizle sistematik ve güvenli bağlantılar sağlayın. İntek Electronic, kablo düzenleme ve pano içi gruplamada uzman çözümler sunar.'
        },
        {
          name: 'keywords',
          content: 'kablo gruplama, kablo düzenleme, kablo bağlantısı, pano içi kablo, kablo grubu çözümleri, intek elektronik'
        },
        {
          property: 'og:title',
          content: 'Kablo Gruplama | İntek Electronic'
        },
        {
          property: 'og:description',
          content: 'İntek Electronic ile kablolarınız daha düzenli ve sistematik. Endüstriyel sistemler için kablo gruplama hizmeti.'
        },
        {
          property: 'og:image',
          content: 'https://www.intekelectronic.com.tr/images/cable-group.jpg'
        },
        {
          property: 'og:url',
          content: 'https://www.intekelectronic.com.tr/kablo-gruplama'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.intekelectronic.com.tr/kablo-gruplama'
        }
      ]
    });

    onMounted(async () => {
      let q = query(collection(firestore, "kablo"), where("durum", "==", true));
      const querySnapshot = await getDocs(q);
      const veri = [];
      querySnapshot.forEach((doc) => {
        veri.push({ ...doc.data(), id: doc.id });
      });
      cables.value = veri;
    });

    return {
      cables,
    };
  },
};
</script>

<style scoped>
.portfolio-item {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.portfolio-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  border-radius: 4px;
}

.portfolio-item:hover img {
  transform: scale(1.05);
}

.portfolio-hover {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.5);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.portfolio-link:hover .portfolio-hover {
  opacity: 1;
}

.portfolio-hover-content {
  color: #fff;
  font-size: 2rem;
}
.portfolio-caption {
  text-align: center;
  margin-top: 0.5rem;
}
.modal-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
@media (max-width: 768px) {
  .title-column h1 {
    font-size: 1.8rem;
    text-align: center;
  }
  .bread-crumb {
    justify-content: center;
    font-size: 0.95rem;
  }
}
</style>
